import { Link } from 'react-router-dom';
import { brand } from '../content/site';
import Brand from './Brand';
import { localizedPath, useLocale, useMessages } from '../i18n/locale';

export default function SiteFooter() {
  const locale = useLocale();
  const messages = useMessages();
  const copy = messages.footer;
  return (
    <footer className="site-footer">
      <div className="container footer-main">
        <div>
          <Brand />
          <p>
            {copy.description[0]}
            <br />
            {copy.description[1]}
          </p>
        </div>
        <div className="footer-links">
          <div>
            <strong>{copy.explore}</strong>
            <Link to={localizedPath(locale, '/open-source')}>{messages.navigation.openSource}</Link>
            <Link to={localizedPath(locale, '/services')}>{messages.navigation.services}</Link>
          </div>
          <div>
            <strong>{copy.resources}</strong>
            <Link to={localizedPath(locale, '/docs')}>{messages.navigation.docs}</Link>
            <Link to={localizedPath(locale, '/community')}>{messages.navigation.community}</Link>
            <Link to={localizedPath(locale, '/company')}>{copy.aboutUs}</Link>
          </div>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>
          © {new Date().getFullYear()} {brand.name}. {copy.rights}
        </span>
        <span>{brand.tagline.toUpperCase()}</span>
        <span>{copy.closing}</span>
      </div>
    </footer>
  );
}
